// src/routes/AppRoutes.tsx
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Home from '../pages/Home/Home';
import About from '../pages/About/About';
import Donate from '../pages/Donate/Donate';
import Events from '../pages/Events/Events';
import Missions from '../pages/Missions/Missions';
import Resources from '../pages/Resources/Resources';
import Volunteer from '../pages/Volunteer/Volunteer';
import PatientPayment from '../pages/PatientPayment/PatientPayment';
import ContactUs from '../pages/ContactUs/ContactUs';
import Login from '../pages/Admin/Auth/Login';
import ForgotPassword from '../pages/Admin/Auth/ForgotPassword';
import Layout from '../components/layout/public/Layout';
import NewPasswordPage from '../pages/Admin/Auth/NewPasswordPage';
import DonateSuccess from '../pages/Donate/DonateSuccess';
import DonateCancel from '../pages/Donate/DonateCancel';
import TermOfServiceAndConditions from '../pages/TermServiceCondition/TermOfServiceAndConditions';
import PrivacyPolicy from '../pages/PrivacyPolicy/PrivacyPolicy';
import ContactSuccess from '../pages/ContactUs/ContactSuccess';
import VolunteerSuccess from '../pages/Volunteer/VolunteerSuccess';


interface AppRoutesProps {
  isAuthenticated: boolean;
}

const AppRoutes: React.FC<AppRoutesProps> = ({ isAuthenticated }) => {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/donate" element={<Donate />} />
        <Route path="/donate/success" element={<DonateSuccess />} />
        <Route path="/donate/cancel" element={<DonateCancel />} />
        <Route path="/events" element={<Events />} />
        <Route path="/missions" element={<Missions />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/volunteer" element={<Volunteer />} />
        <Route path="/patient-payment" element={<PatientPayment />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/terms-of-service" element={<TermOfServiceAndConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/login" element={<Login />} />
        <Route path="/new-password" element={<NewPasswordPage />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/contact/success" element={<ContactSuccess />} />
        <Route path="/volunteer/success" element={<VolunteerSuccess />} />
        {isAuthenticated ? (
          // Add authenticated routes here
          <Route path="/" element={<Home />} />
        ) : (
          <Route path="*" element={<Navigate to="/login" />} />
        )}
      </Route>
      {/* ... other routes */}
    </Routes>
  );
};

export default AppRoutes;
